export default "__VITE_ASSET__0d490cf5__"